// extracted by mini-css-extract-plugin
export default {"footerMenuGroup":"Sidebar_footerMenuGroup__CQSk1","sider":"Sidebar_sider__8UMF4","logoWrapper":"Sidebar_logoWrapper__Q2gAD"};